
var stache = require('can/view/stache/stache');
module.exports = stache("<button class=\"c-scroll-top\" aria-label=\"top\">\r\n    <span class=\"c-scroll-top__icon\"></span>\r\n    TOP\r\n</button>");